import { GeographicalZone } from '../types/interfaces';


export const GeographicalZoneTemplate: GeographicalZone = {
  id: '',
  name: '',
  description: '',
  addresses: [],
  avgTransportSpeed: null
};
